/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { service } from '@ember/service';
import appConfig from 'my-phorest/config/environment';

export default class DevInfoComponent extends Component {
  @service revisionKey;
  @service router;
  @service session;
  @service('browser/window') window;

  deployTarget = appConfig.deployTarget;
  embeddedRevision = this.session.embeddedRevision;

  get readFeatureFlagsFromLocal() {
    return appConfig.launchDarkly.mode === 'local';
  }

  get showDevInfo() {
    return (
      this.revisionKey.key ||
      (this.deployTarget !== 'production' &&
        this.deployTarget !== 'cloudfront-prod')
    );
  }

  get showFeatureFlagsLinks() {
    return (
      this.router.currentRouteName?.includes('accounts.account') &&
      this.args.enableFeatureFlagsLinks &&
      this.readFeatureFlagsFromLocal
    );
  }
}
